import React from 'react';
import { useCalendar } from '../features/calendar/hooks/useCalendar';
import { CalendarHeader } from '../features/calendar/components/CalendarHeader';
import { CalendarGrid } from '../features/calendar/components/CalendarGrid';
import { EventList } from '../features/calendar/components/EventList';

const CalendarPage: React.FC = () => {
  const {
    currentDate,
    selectedDate,
    setSelectedDate,
    events,
    getEventsForDate,
    nextMonth,
    prevMonth,
    goToToday
  } = useCalendar();

  return (
    <div className="min-h-screen bg-[#f8fafc] p-4 md:p-6 lg:p-8">
      <div className="max-w-7xl mx-auto">
        <CalendarHeader
          currentDate={currentDate}
          onNext={nextMonth}
          onPrev={prevMonth}
          onToday={goToToday}
        />

        <div className="flex flex-col lg:flex-row gap-6">
          <div className="flex-1">
            <CalendarGrid
              currentDate={currentDate}
              selectedDate={selectedDate}
              onSelectDate={setSelectedDate}
              getEventsForDate={getEventsForDate}
            />
          </div>
          <div className="w-full lg:w-80 xl:w-96 flex-shrink-0">
            <EventList
              events={events}
              currentDate={currentDate}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CalendarPage;
